export function SettingsIcon({ color }: { color?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="m10.16 3.84-1.41-.63 1.4-.64.64-1.4.64 1.4 1.4.64-1.4.63-.64 1.41zm2.25 3.58-.45-1-.46 1-1 .46 1 .45.46 1 .45-1 1-.45zm-2.94.96 1.13.86-1.45 2.53-1.31-.55-.37.21-.18 1.4H4.37l-.17-1.4-.37-.22-1.31.55-1.46-2.53 1.13-.85v-.43L1.06 7.1l1.46-2.52 1.3.55Q4 5 4.2 4.9l.17-1.4H7.3l.18 1.4.37.22 1.3-.55 1.47 2.53-1.14.86v.42m-1.89-.21a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0"
        fill={color || "currentColor"}
      />
    </svg>
  );
}
